export default "<p>\n  profile-update-member works!\n</p>\n"